"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALGO_LICENSE_ID = void 0;
var ALGO_LICENSE_ID = {
  IHC_HER2_BREAST_DAKO_HERCEPTEST_V1: 10010,
  IHC_HER2_BREAST_V1: 10011,
  IHC_ER_BREAST_DAKO_CLONE1D5_V1: 10014,
  IHC_PR_BREAST_DAKO_CLONEPGR636_V1: 10015,
  IHC_HER2_BREAST_TUMOR_CELL_DETECTION_V1: 10021,
  IHC_ER_BREAST_V1: 10022,
  IHC_ER_BREAST_TUMOR_CELL_DETECTION_V1: 10023,
  IHC_PR_BREAST_V1: 10024,
  IHC_PR_BREAST_TUMOR_CELL_DETECTION_V1: 10025,
  IHC_MEMBRANE_V1: 10028,
  IHC_NUCLEAR_V1: 10029,
  POSITIVE_PIXEL_COUNT_V9: 10017,
  POSITIVE_PIXEL_COUNT_2004_08_11: 10016,
  POSITIVE_PIXEL_COUNT_FL_V1: 20001,
  AREA_QUANTIFICATION_FL_V1: 20003,
  RARE_EVENT_DETECTION_V1: 10007,
  NUCLEAR_V9: 10013,
  MEMBRANE_V9: 10009,
  RNA_ISH_V2: 40002
};
exports.ALGO_LICENSE_ID = ALGO_LICENSE_ID;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/macros/consts.js
// module id = 277
// module chunks = 0